import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import favicon from "@/assets/favicon.ico";

const faviconLink = document.querySelector("link[rel~='icon']") || document.createElement("link");
faviconLink.type = "image/x-icon";
faviconLink.rel = "icon";
faviconLink.href = favicon;
document.head.appendChild(faviconLink);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
